import Button from "@/components/Button";
import Dialog from "@/components/Dialog";

export type FinalizePricingModalProps = {
  onDismiss: () => void;
  handleFinalizePricing: () => void;
  headline: string;
  buttonText: string;
  description: string;
  successDescription: string;
  errors: Record<string, string[]>[];
  loading: boolean;
  success: boolean;
};

export const FinalizePricingModal = ({
  onDismiss,
  handleFinalizePricing,
  headline,
  buttonText,
  description,
  successDescription,
  errors,
  loading,
  success
}: FinalizePricingModalProps) => {
  const actions = (
    <>
      <Button variant="text" onClick={onDismiss}>
        Cancel
      </Button>

      <Button
        onClick={handleFinalizePricing}
        icon={loading ? "progress_activity" : undefined}
        disabled={loading}
        iconClassName="animate-spin w-6 h-6 !block"
      >
        {loading ? "Finalizing" : buttonText}
      </Button>
    </>
  );

  return errors?.length === 0 ? (
    <>
      {success ? (
        <Dialog
          onClosed={onDismiss}
          open
          actions={<Button onClick={onDismiss}>Done</Button>}
          headline="Dues Finalized"
          className="w-[480px]"
          displayOverflow
        >
          <p>{successDescription}</p>
        </Dialog>
      ) : (
        <Dialog onClosed={onDismiss} open actions={actions} headline={headline} className="w-[480px]" displayOverflow>
          <p>{description}</p>
        </Dialog>
      )}
    </>
  ) : (
    <Dialog
      onClosed={onDismiss}
      open
      actions={<Button onClick={onDismiss}>Go Back</Button>}
      headline="Dues Cannot Be Finalized"
      className="w-[480px]"
      displayOverflow
    >
      <p>Please make sure all rate errors have been fixed before finalizing dues.</p>
    </Dialog>
  );
};
